export default "__VITE_PUBLIC_ASSET__f01209cb__"